import { NgZone } from '@angular/core';
import { Observable, type Subscriber } from 'rxjs';

import { returnAsArray } from '@plugins/shared/utils/arrayUtils/array-utils';

const subscriberNext = <T>(
  subscriber: Subscriber<T>,
  entries: T,
  zone?: NgZone,
): void => {
  if (zone) {
    zone.run(() => subscriber.next(entries));
    return;
  }
  subscriber.next(entries);
};

/** Transform the ResizeObserver instance into an RxJS observable. */
export const resizeObservable = (
  el: Element | Element[],
  zone?: NgZone,
): Observable<ResizeObserverEntry[]> => {
  const elements = returnAsArray(el);
  return new Observable((subscriber: Subscriber<ResizeObserverEntry[]>) => {
    const resizeObserver = new ResizeObserver((entries) => {
      subscriberNext(subscriber, entries, zone);
    });
    elements.forEach((element) => resizeObserver.observe(element));
    return () => resizeObserver.disconnect();
  });
};

export const mutationObservable = (
  el: Element | Element[],
  config: MutationObserverInit,
  zone?: NgZone,
): Observable<MutationRecord[]> => {
  const elements = returnAsArray(el);
  return new Observable((subscriber: Subscriber<MutationRecord[]>) => {
    const mutationObserver = new MutationObserver((records) =>
      subscriberNext(subscriber, records, zone),
    );
    elements.forEach((element) => mutationObserver.observe(element, config));
    return () => mutationObserver.disconnect();
  });
};
